import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

declare const grecaptcha: {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
};

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  loadRecaptcha() {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${environment.recaptcha.siteKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  execute(action: string): Observable<string> {
    return new Observable<string>((observer) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(environment.recaptcha.siteKey, { action }).then(
          (token) => {
            observer.next(token);
            observer.complete();
          },
          (error) => observer.error(error)
        );
      });
    });
  }
}
